import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { ActionHelper } from "../../../../helper/action.helper";

@Component({
  selector: 'fi-lead-process',
  templateUrl: './lead-process-popup.component.html',
  styleUrls: ['./lead-process-popup.component.scss'],
  standalone: false,
})
export class LeadProcessPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  searchedText = '';
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_PROCESS', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_PROCESS', true);
  submitting: boolean;
  isMany: boolean;
  leads: number[];
  private cancel = false;
  step: number = 0;
  inValidNote = false;
  isExternal: boolean;

  constructor(
    public dialogRef: MatDialogRef<LeadProcessPopupComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, externalEmail: string, leads: number[], isMany: boolean},
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.isMany = dialogData?.isMany;
    this.leads = dialogData?.leads;
    this.isExternal = !!dialogData?.externalEmail;

    leadsMultipleStepByStepService.listenToCancel().subscribe(data => {
      this.cancel = true;
    })
    if (this.isExternal) {
      this.darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_PROCESS_EXT', true);
    }
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    if (this.isMany) {
      return this.leads.length > 0 && !this.inValidNote && !this.submitting;
    }
    return !!this.leadId && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }


  submitStepByStep(): void {
    if (this.cancel) {
      return;
    }
    this.clearClassAndCloseDialog(this.dialogRef, 'remove');

    this.actionDataService.completeRequest(this.leads[this.step], this.note).subscribe(({ success, data }) => {
      if (this.leads.length - 1 === this.leads.lastIndexOf(this.leads[this.step])) {
        this.submitting = false;
      }

      this.step++;
      this.leadsMultipleStepByStepService.switchToNextStep();

      if (this.leads[this.step]) {
        this.submitStepByStep();
      }
    });
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;

      if (this.isMany) {
        let action: any = {
          Name: 'MULTIPLE_LEADS_STEP_BY_STEP',
          Text: 'Bald geschafft...',
          leadsLength: this.leads.length,
          actionName: 'LEAD_PROCESS'
        }
        ActionHelper.doAction({} as any, action, this.dialog, this.leads, true)?.afterClosed().subscribe();
        this.submitStepByStep();
      } else {
        this.actionDataService.completeRequest(this.leadId, this.note, this.isExternal).subscribe(({ success, data }) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove').then();
          }

          this.submitting = false;
        });
      }
    }
  }
}
